export default {
    flexcontainer: {},

    buttoncontainer: {},

    dialogContent: {
        width: '310px',
        top: '72px',
        left: '237.109px',
    },

    dialogBodyContent: {
        padding: '0',
        minHeight: '300px',
        minWidth: '310px',
        left: '11vw',
    },

    RangeButton: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        textAlign: 'center',
        overflow: 'auto',
        width: '254px',
        position: 'relative',
        left: '2px',
        bottom: '14px',
        padding: '0px',
        minHeight: '329px',
    },

    okButton: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginLeft: 'auto',
        position: 'relative',
        right: '2%',
    },

    flexInnerContainer: {
        display: 'inline-flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },

    customrange: {
        display: 'inline-block',
        top: '20px',
        position: 'relative',
        margin: '0% 7px 22px 10px',
        fontSize: '16px',
        height: '35px',
        padding: '6px 10px',
        textTransform: 'capitalize',
        color: 'grey',
        fontWeight: '500',
    },

    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
        padding: '9px 0px 15px 0px',
    },

    customRangeContainer: {
        display: 'inline-flex',
    },

    dateRangeContainer: {
        height: '190px',
        overflowY: 'scroll',
    },

    Animating: {
        fonSize: '2rem',
        position: 'relative',
        animation: 'iconanimation  ease-in-out 0.8s  infinite alternate',
        cursor: 'pointer',
    },

    '@keyframes iconanimation': {
        from: {
            top: '-1px',
        },

        to: {
            top: '1px',
        },
    },

};


// WEBPACK FOOTER //
// ./src/components/input/DateRange/styles/DateRangeSelectorDialog.js